module.exports = __webpack_public_path__ + "img/logo4.62d2c85e.png";